module.exports = __webpack_public_path__ + "img/logo.51b3a759.png";